import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ptBR from './locales/pt-BR.json'
import es from './locales/es.json'
import fr from './locales/fr.json'

const messages = {
  en,
  'pt-BR': ptBR,
  es,
  fr
}

function getStartingLocale() {
  let savedLanguage = localStorage.getItem('language')
  if (savedLanguage === 'pt') savedLanguage = 'pt-BR'; // Migrate old pt
  
  if (savedLanguage && messages[savedLanguage]) {
    return savedLanguage
  }
  
  const candidateLangs = (typeof navigator !== 'undefined' && navigator.languages && navigator.languages.length)
    ? navigator.languages
    : [(typeof navigator !== 'undefined' && navigator.language) ? navigator.language : 'pt-BR'];

  for (const raw of candidateLangs) {
    if (!raw) continue;
    const clean = raw.replace('_', '-');
    if (messages[clean]) return clean;
    const short = clean.split('-')[0].toLowerCase();
    if (short === 'pt') return 'pt-BR';
    if (messages[short]) return short;
  }
  
  return 'pt-BR'
}

const i18n = createI18n({
  legacy: false, // using Composition API
  globalInjection: true, // injects $t, $i18n into all components
  locale: getStartingLocale(),
  fallbackLocale: 'en',
  messages
})

export const setLanguage = (locale) => {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }
  localStorage.setItem('language', locale)

  // Fire and forget update to backend
  fetch('/api/user/notifications', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ locale })
  }).catch(err => console.error('Failed to sync locale:', err))
}

export default i18n
